import { gql } from "shared/lib/graphql"

export const SubscriptionUpdateMutation = gql`
  mutation($product_id: String!) {
    userSubscriptionUpdate(input: { product_id: $product_id }) {
      user_subscription {
        plan_id
      }
      errors {
        attribute
        message
      }
    }
  }
`

export const TierPricesQuery = gql`
  query {
    tier_prices {
      pro {
        month {
          currency
          formatted
          formatted_monthly
        }

        year {
          currency
          formatted
          formatted_monthly
        }
      }
    }
  }
`
